export const socialLinks = {
  facebook: 'https://www.facebook.com/boldarecom/',
  linkedin: 'https://www.linkedin.com/company/boldarecom/',
  instagram: 'https://www.instagram.com/boldarecom/',
  x: 'https://x.com/boldarecom',
  behance: 'https://www.behance.net/boldarecom',
  dribbble: 'https://dribbble.com/Boldare',
  youtube: 'https://www.youtube.com/channel/UCOTEkbD0MSAmBzGFNrnRaxQ',
};
